"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CallUtils {
    static callUser(userId, receiverPhoneNumber, _meta) {
        if (receiverPhoneNumber) {
            sessionStorage.setItem("__receiverPhoneNumber__", receiverPhoneNumber.toString());
        }
        else {
            sessionStorage.setItem("__userId__", userId.toString());
        }
        if (_meta !== null && _meta !== undefined) {
            sessionStorage.setItem("__paramsMeta__", JSON.stringify(_meta));
        }
        const callEvent = new Event(this.CALL_USER_EVENT);
        document.dispatchEvent(callEvent);
    }
}
exports.CallUtils = CallUtils;
CallUtils.CALL_USER_EVENT = "CALL_USER";
